<script setup>
import { computed } from 'vue';

const props = defineProps({
    table: {
        type: Object,
        required: true,
    },
    count: {
        type: Number,
        required: false,
    },
});

const page = computed(() => props.table.getState().pagination.pageIndex + 1);

const pageSize = computed(() => props.table.getState().pagination.pageSize);

const count = computed(() =>
    props.count ? props.count : props.table.getCoreRowModel().rows.length,
);
</script>

<template>
    <span v-if="props.table.getPageCount() > 1" class="text-sm">
        Affichage de {{ page * pageSize - pageSize + 1 }} à
        {{ Math.min(page * pageSize, count) }} sur {{ count }} entrées
    </span>
</template>
